module.exports = __webpack_public_path__ + "static/media/fridge.84699de0.svg";